import { getSharepointDocuments } from '../../graphql/queries';
import isInGroup from '../../services/util/isInGroup';
import {
  GET_DOCUMENTS_ADVISERS_ABORTED,
  GET_DOCUMENTS_ADVISERS_REQUESTED,
  GET_DOCUMENTS_ADVISERS_COMPLETED,
  GET_DOCUMENTS_ADVISERS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

const getDocumentsForAdviserAction = () => async (dispatch, getState) => {
  const { advisers, documentsAdvisers, session } = getState();
  const sessionData = session.get('data');
  const adviser = advisers.get('set');
  const documentsAdvisersData = Object.create(documentsAdvisers.get('data'));

  if (!documentsAdvisersData.items) {
    documentsAdvisersData.items = [];
  }

  const ContactID = null;
  const ProfessionalContactID = adviser?.ProfessionalContactID ?? null;
  const ProfessionalFirmID = adviser?.ProfessionalFirmID;

  let documentsadvisers;
  // if you are an adviser -
  if (
    isInGroup(sessionData, 'Adviser') &&
    (documentsAdvisersData?.items ?? []).length > 0
  ) {
    // eslint-disable-next-line prefer-destructuring
    documentsadvisers = documentsAdvisersData.items[0];
    // if you are an admin impersonating adviser
  } else if (ProfessionalFirmID) {
    documentsadvisers = documentsAdvisersData.items.find(
      (item) => ProfessionalFirmID === item.ProfessionalFirmID,
    );
  }

  if (documentsadvisers) {
    debug('Running abort - GET_DOCUMENTS_ADVISERS_ABORTED');

    dispatch({
      type: GET_DOCUMENTS_ADVISERS_ABORTED,
    });

    return;
  }

  debug('Get documents advisers Running --', 'getDocumentsForAdviserAction');

  dispatch({
    type: GET_DOCUMENTS_ADVISERS_REQUESTED,
  });

  try {
    const { data } = await api.graphql({
      query: getSharepointDocuments,
      variables: {
        ContactID,
        ProfessionalContactID,
      },
    });

    documentsAdvisersData.items.push(data?.getSharepointDocuments ?? []);

    const payload = { items: documentsAdvisersData.items || [] };

    dispatch({
      type: GET_DOCUMENTS_ADVISERS_COMPLETED,
      payload,
    });

    debug('end getDocumentsForAdviserAction');
  } catch (err) {
    debug(GET_DOCUMENTS_ADVISERS_FAILED, err);

    dispatch({
      type: GET_DOCUMENTS_ADVISERS_FAILED,
      payload: err,
    });
  }
};

export default getDocumentsForAdviserAction;
